module.exports = __webpack_public_path__ + "img/hydranautics.fc58942e.png";